export default "__VITE_ASSET__BR1pqjKI__"